

























































































































import {
  HeaderActionDispatcher,
  OpportunityIcon,
  OpportunityStatus,
  OpportunityTags,
  OpportunityFilter,
  OpportunityCounters,
} from '@/components/opportunities';
import { GenerateOpportunityReportModal } from '@/components/opportunities/modals';
import { Counter, OpportunityListItem, OpportunityFilters, OpportunityItemStatus } from '@/models/opportunities';
import { isOpportunityInactive } from '@/shared';
import { Actions } from '@/store';
import Vue from 'vue';
import { OpportunityDraftListItem } from '../../models/opportunities';

export default Vue.extend({
  name: 'Opportunity',
  components: {
    GenerateOpportunityReportModal,
    HeaderActionDispatcher,
    OpportunityIcon,
    OpportunityStatus,
    OpportunityTags,
    OpportunityCounters,
    OpportunityFilter,
  },
  data() {
    return {
      loader: {
        isOpportunitiesListPending: true,
      },
      filters: {},
    };
  },
  async created(): Promise<void> {
    await this.$store.dispatch(Actions.opportunities.fetchCounters);
    await this.$store.dispatch(Actions.opportunities.drafts.fetchOpportunitiesDrafts);
  },
  computed: {
    opportunities(): OpportunityListItem[] {
      return this.$store.state.opportunities.opportunities;
    },
    opportunityDrafts(): OpportunityDraftListItem[] {
      return this.$store.state.opportunities.drafts.opportunitiesDrafts;
    },
    counters(): Counter[] {
      return this.$store.state.opportunities.counters;
    },
    areMoreItemsAvailable(): boolean {
      return this.opportunities.length < this.$store.state.opportunities.pagination.totalCount &&
             this.opportunities.length > 0;
    },
  },
  methods: {
    async loadMoreElements() {
      this.loader.isOpportunitiesListPending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.fetchMoreOpportunities, this.filters);
      } finally {
        this.loader.isOpportunitiesListPending = false;
      }
    },
    goToOpportunityDetails(id: string) {
      this.$router.push({ name: 'opportunity-details', params: { id } });
    },
    goToOpportunityDraftDetails(id: string) {
      this.$router.push({ name: 'opportunity-draft-details', params: { id } });
    },
    openGenerateReportModal() {
      this.$bvModal.show('generate-report-modal');
    },
    async updateFilters(filters: OpportunityFilters) {
      this.filters = filters;
      this.loader.isOpportunitiesListPending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.fetchOpportunities, this.filters);
      } finally {
        this.loader.isOpportunitiesListPending = false;
      }
    },
    isOpportunityInactive,
  },
});
